import React from 'react';
import { ShieldCheck, Stethoscope, Award, HeartHandshake, MapPin } from 'lucide-react';

/**
 * Horizontal trust strip used on Home + condition landing pages.
 * Elegant gold-iconed pills, consistent with brand palette.
 * Pass `showLocation` to surface a Utah-licensed badge on condition pages.
 */
const TrustStrip = ({ variant = 'default', showLocation = false }) => {
  const items = [
    { icon: ShieldCheck, label: 'HIPAA Compliant' },
    { icon: Stethoscope, label: 'Licensed Clinicians' },
    { icon: Award, label: 'Board-Certified PA-C & NP' },
    { icon: HeartHandshake, label: '60-Day Care Promise' },
  ];

  if (showLocation) {
    items.unshift({ icon: MapPin, label: 'Utah-Licensed Clinicians' });
  }

  return (
    <div className={`trust-strip trust-strip-${variant}`} data-testid="trust-strip">
      <div className="trust-strip-inner">
        {items.map(({ icon: Icon, label }) => (
          <div className="trust-strip-item" key={label}>
            <Icon size={16} strokeWidth={1.5} />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustStrip;
